import { getDisplaySubjectLine } from 'find-and-filter-data/view-members-schema/public';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import ReassignmentSelectDropdownContainer from '../../reassignment/ReassignmentSelectDropdownContainer';
import { getThreadListMemberByThreadId } from '../../thread-list-member/selectors/getThreadListMemberByThreadId';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "ThreadToolbar__StyledDiv",
  componentId: "sc-6pni77-0"
})(["align-self:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-bottom:2px;"]);
export const ThreadToolbar = ({
  threadId,
  inboxId
}) => {
  const threadListMember = useSelector(state => getThreadListMemberByThreadId(state, {
    threadId
  }));
  const subject = useMemo(() => getDisplaySubjectLine(threadListMember), [threadListMember]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    justify: "between",
    "data-test-id": "thread-toolbar",
    children: [/*#__PURE__*/_jsx(ReassignmentSelectDropdownContainer, {
      threadId: threadId,
      inboxId: inboxId
    }), /*#__PURE__*/_jsx(StyledDiv, {
      role: "heading",
      children: subject
    })]
  });
};
ThreadToolbar.displayName = 'ThreadToolbar';
export default ThreadToolbar;